import { Pipe, PipeTransform } from '@angular/core';
import { translateIdTagUserAccessTypeEnum } from '../mappers/enum-translation-mapper';
import { ChargingUserCreationAccessTypeEnum } from '../enums/charging-user-generation-access-type';

@Pipe({
  name: 'translateChargingUserCreationAccessTypeEnum',
})
export class TranslateChargingUserCreationAccessTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const enumElement = element as { name: string; index: number };
        enumElement.name = translateIdTagUserAccessTypeEnum(enumElement.index as unknown as ChargingUserCreationAccessTypeEnum);
      });
      return value;
    }
    return translateIdTagUserAccessTypeEnum(value);
  }
}
